export const articles = [
  {
    id: 'jianjing-5fz',
    slug: 'jianjing-5fz',
    title: '5分钟肩颈放松按摩：办公室一族的每日必修课',
    categoryId: 'jianjing',
    summary: '每天只需5分钟，学会这套简单有效的肩颈放松按摩手法，告别肩颈酸痛，提升工作效率。适合长期伏案工作的上班族。',
    publishDate: '2026-07-28',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Soft%20warm%20spa%20interior%20with%20wooden%20massage%20table%20and%20folded%20white%20towels%2C%20natural%20sunlight%20streaming%20through%20sheer%20curtains%2C%20essential%20oil%20bottles%20on%20side%20table%2C%20peaceful%20wellness%20atmosphere%2C%20minimalist%20design%2C%20warm%20beige%20and%20cream%20tones%2C%20editorial%20photography&width=800&height=500&seq=article-jianjing-5fz&orientation=landscape',
    content: [
      { type: 'heading', text: '为什么肩颈按摩如此重要？' },
      { type: 'paragraph', text: '现代社会中，长时间使用电脑和手机已成为常态。不正确的坐姿加上缺乏运动，导致肩颈部位肌肉长期处于紧张状态。据调查，超过70%的办公室工作者存在不同程度的肩颈不适问题。定期进行肩颈按摩，不仅能缓解肌肉酸痛，还能预防颈椎病的发生。' },
      { type: 'heading', text: '准备工作' },
      { type: 'paragraph', text: '在开始按摩之前，请准备好以下物品：一条干净的毛巾、适量的按摩油或乳液（推荐使用薰衣草或薄荷精油），以及一个安静舒适的环境。建议在按摩前先用热毛巾敷在肩颈部位3-5分钟，帮助肌肉放松。' },
      { type: 'heading', text: '第一步：颈部放松（1分钟）' },
      { type: 'paragraph', text: '坐直身体，双手自然放在膝盖上。缓慢地将头部向前后左右四个方向各转动5次，感受颈部肌肉的拉伸。注意动作要缓慢轻柔，不要用力过猛。然后用右手轻轻按住左侧头部，缓慢向右侧拉伸，保持15秒，换边重复。' },
      { type: 'heading', text: '第二步：肩部揉捏（1.5分钟）' },
      { type: 'paragraph', text: '用右手捏住左肩的肌肉，从颈部根部开始，沿着肩膀向外侧进行揉捏。力度以感觉舒适为宜，不要过度用力。每个部位揉捏10-15次后移动到下一个位置。特别注意肩井穴（位于肩膀最高点）周围的按摩。' },
      { type: 'heading', text: '第三步：穴位按压（1.5分钟）' },
      { type: 'paragraph', text: '找到风池穴（位于后颈部，头骨下方的凹陷处），用双手拇指同时按压，力度适中，按压5秒后松开，重复10次。接着找到肩井穴，用拇指按压10秒，重复5次。这些穴位对于缓解头痛和肩颈酸痛非常有效。' },
      { type: 'heading', text: '第四步：收尾放松（1分钟）' },
      { type: 'paragraph', text: '完成上述步骤后，用手指轻轻梳理颈部和肩部的肌肉，帮助血液循环。然后做几次深呼吸，感受身体的放松状态。建议每天坚持练习，效果会更加明显。' },
      { type: 'heading', text: '注意事项' },
      { type: 'paragraph', text: '1. 按摩时力度要循序渐进，初次尝试时不宜用力过猛。2. 如果有颈椎病或肩周炎等疾病，请在医生指导下进行按摩。3. 按摩后多喝温水，有助于代谢废物的排出。4. 如果按摩过程中出现剧烈疼痛，应立即停止。' },
    ],
    tags: ['肩颈按摩', '办公室放松', '穴位按摩', '居家按摩'],
    faq: [
      { question: '肩颈按摩每天可以做几次？', answer: '一般建议每天1-2次，每次5-10分钟为宜。过度按摩可能会导致肌肉疲劳，反而不利于恢复。' },
      { question: '按摩时感觉疼痛正常吗？', answer: '轻微的酸胀感是正常的，说明肌肉确实存在紧张。但如果出现剧烈疼痛或刺痛感，应立即停止并咨询专业医生。' },
    ],
  },
  {
    id: 'quanshen-15fz',
    slug: 'quanshen-15fz',
    title: '15分钟全身放松按摩教程：从入门到精通',
    categoryId: 'quanshen-fangsong',
    summary: '一套完整的全身放松按摩流程，从头到脚系统性地放松全身肌肉，适合在家自行操作或与家人互相按摩。',
    publishDate: '2026-07-25',
    readTime: '12分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Serene%20spa%20room%20with%20bamboo%20accents%20and%20soft%20candlelight%2C%20white%20massage%20table%20with%20fresh%20flowers%2C%20wooden%20floor%20and%20natural%20textures%2C%20calm%20therapeutic%20environment%2C%20warm%20neutral%20palette%2C%20professional%20wellness%20photography&width=800&height=500&seq=article-quanshen-15fz&orientation=landscape',
    content: [
      { type: 'heading', text: '全身放松按摩的好处' },
      { type: 'paragraph', text: '全身按摩是一种通过手法作用于人体体表特定部位，以调节机体生理状况的保健方法。规律的全身按摩可以促进血液循环、缓解肌肉疲劳、改善睡眠质量、增强免疫力，是现代人缓解压力的重要方式之一。' },
      { type: 'heading', text: '按摩前的准备' },
      { type: 'paragraph', text: '选择一个温度适宜（24-26℃）、光线柔和的房间。准备按摩床或瑜伽垫、干净的床单、按摩油（推荐甜杏仁油或葡萄籽油）。被按摩者应穿着宽松舒适的衣物，保持放松的心态。' },
      { type: 'heading', text: '背部按摩（5分钟）' },
      { type: 'paragraph', text: '从腰部开始，用掌根沿着脊柱两侧向上推至肩部，力度由轻到重。然后用拇指在脊柱两侧的膀胱经上进行点按，每个穴位按压3-5秒。最后用双手揉捏肩部和背部的肌肉群，放松紧张的肌肉纤维。' },
      { type: 'heading', text: '腿部按摩（4分钟）' },
      { type: 'paragraph', text: '从脚踝开始向上推揉，重点按摩小腿肚和大腿后侧的肌肉。用拇指按压足三里穴（膝盖下方约四指处）和承山穴（小腿肚中央），每个穴位按压5秒。' },
      { type: 'heading', text: '手臂和手部按摩（3分钟）' },
      { type: 'paragraph', text: '从手腕向上推揉至肩膀，注意力度要均匀。重点按摩合谷穴（虎口处）和曲池穴（肘部外侧），这些穴位有助于缓解手臂疲劳和头痛。' },
      { type: 'heading', text: '头部和面部按摩（3分钟）' },
      { type: 'paragraph', text: '用手指指腹从前额开始，沿着头皮向后轻轻按摩。重点按压太阳穴、印堂穴和百会穴，帮助放松神经、缓解头痛。面部按摩要格外轻柔，从下巴向上推至太阳穴。' },
      { type: 'heading', text: '按摩后的护理' },
      { type: 'paragraph', text: '按摩结束后，建议休息5-10分钟再起身。多喝温水帮助排出代谢废物。24小时内避免剧烈运动和冷水浴，让身体充分吸收按摩带来的益处。' },
    ],
    tags: ['全身按摩', '放松技巧', '居家按摩', '养生保健'],
    faq: [
      { question: '全身按摩多久做一次合适？', answer: '一般建议每周1-2次。过于频繁可能导致肌肉适应性降低，间隔时间过长则效果不明显。根据个人身体状况适当调整。' },
      { question: '按摩后为什么会出现酸痛？', answer: '这是正常的"好转反应"，说明按摩促进了局部血液循环和代谢。通常1-2天内会自行消退，多喝水可以加速代谢废物的排出。' },
    ],
  },
  {
    id: 'xuewei-hegu',
    slug: 'xuewei-hegu',
    title: '人体十大保健穴位详解：合谷穴的按摩方法与功效',
    categoryId: 'xuewei',
    summary: '详细介绍合谷穴的位置、按摩手法和保健功效。学会正确按压合谷穴，轻松缓解头痛、牙痛和面部不适。',
    publishDate: '2026-07-22',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Traditional%20Chinese%20medicine%20acupressure%20chart%20on%20warm%20wooden%20background%2C%20dried%20herbs%20and%20essential%20oil%20arrangement%2C%20soft%20natural%20lighting%2C%20wellness%20and%20holistic%20health%20concept%2C%20earthy%20tones%2C%20zen%20atmosphere%2C%20editorial%20photography&width=800&height=500&seq=article-xuewei-hegu&orientation=landscape',
    content: [
      { type: 'heading', text: '合谷穴简介' },
      { type: 'paragraph', text: '合谷穴，又称为"虎口"，是手阳明大肠经的原穴，位于手背第一、二掌骨之间。它是中医临床最常用的穴位之一，素有"面口合谷收"之说，对于面部和口腔的各种不适有显著的调理效果。' },
      { type: 'heading', text: '如何准确定位合谷穴' },
      { type: 'paragraph', text: '将拇指和食指并拢，在虎口处会出现一个隆起的肌肉，肌肉的最高点就是合谷穴的位置。也可以这样定位：伸开手掌，用另一只手的拇指横纹对准虎口边缘，拇指弯曲后指尖所指的位置即是合谷穴。' },
      { type: 'heading', text: '正确的按摩手法' },
      { type: 'paragraph', text: '用拇指指腹垂直按压合谷穴，力度由轻到重，以感觉酸胀但不疼痛为宜。每次按压5-10秒后松开，重复10-15次。也可以采用旋转揉按的方式，顺时针和逆时针各揉按30圈。建议每天早晚各按摩一次。' },
      { type: 'heading', text: '合谷穴的主要功效' },
      { type: 'paragraph', text: '1. 缓解头痛：特别是前额痛和偏头痛，按压合谷穴能有效缓解。2. 改善牙痛：对于牙龈肿痛、牙痛有较好的镇痛效果。3. 调理面部问题：面瘫、面部肌肉痉挛等都可以通过刺激合谷穴来改善。4. 缓解感冒症状：鼻塞、流涕等感冒症状，配合按摩合谷穴可以加速康复。' },
      { type: 'heading', text: '注意事项和禁忌' },
      { type: 'paragraph', text: '1. 孕妇禁用合谷穴按摩，因为刺激该穴位可能引起子宫收缩。2. 按摩时不要用力过猛，避免造成局部损伤。3. 如果按摩部位有皮肤破损或感染，应暂停按摩。4. 穴位按摩是辅助保健手段，不能替代正规医疗。' },
    ],
    tags: ['穴位按摩', '合谷穴', '中医养生', '自我保健'],
    faq: [
      { question: '合谷穴按摩多久能见效？', answer: '对于急性头痛和牙痛，通常按摩3-5分钟后就能感受到缓解效果。对于慢性调理，需要坚持每天按摩，一般1-2周后效果逐渐显现。' },
      { question: '可以两侧合谷穴同时按摩吗？', answer: '可以，但建议先按摩一侧1-2分钟后再换另一侧，这样效果更好。如果时间紧张，可以两侧同时进行。' },
    ],
  },
  {
    id: 'zudi-shenshu',
    slug: 'zudi-shenshu',
    title: '足底反射区按摩入门：肾脏反射区的刺激手法',
    categoryId: 'zudi',
    summary: '足底反射区按摩是一种通过刺激足底特定区域来调理全身器官的疗法。本文详细讲解肾脏反射区的位置和按摩方法。',
    publishDate: '2026-07-20',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Foot%20reflexology%20setup%20with%20massage%20oil%20and%20smooth%20river%20stones%20on%20bamboo%20mat%2C%20warm%20spa%20lighting%2C%20soft%20textures%2C%20holistic%20wellness%20scene%2C%20natural%20elements%2C%20cream%20and%20beige%20tones%2C%20professional%20photography&width=800&height=500&seq=article-zudi-shenshu&orientation=landscape',
    content: [
      { type: 'heading', text: '什么是足底反射区按摩？' },
      { type: 'paragraph', text: '足底反射区按摩源于中医的全息理论，认为人体各个器官在足底都有对应的反射区域。通过按摩这些反射区，可以刺激对应的器官和系统，达到调理身体、预防疾病的目的。肾脏反射区是足底按摩中最基础也是最重要的区域之一。' },
      { type: 'heading', text: '肾脏反射区的位置' },
      { type: 'paragraph', text: '肾脏反射区位于双脚脚底中央，大约在脚掌前三分之一和后三分之二的交界处。具体来说，在脚掌中心偏内侧的位置，左右脚各有一个。这个区域呈现凹陷状，触感相对柔软。' },
      { type: 'heading', text: '按摩前的准备工作' },
      { type: 'paragraph', text: '先用温水泡脚10-15分钟，水温以40-45℃为宜。泡脚时可以加入一些浴盐或精油。泡完后用毛巾擦干双脚，涂抹适量的按摩油或乳液，以减少摩擦。选择一个舒适的坐姿，将一只脚放在另一条腿的膝盖上。' },
      { type: 'heading', text: '肾脏反射区按摩手法' },
      { type: 'paragraph', text: '用拇指指腹在肾脏反射区进行顺时针旋转按摩，力度由轻到重，以感觉微微酸胀为宜。每次按摩持续2-3分钟。按摩时可以采用"深压慢揉"的方式——先用拇指深压3秒，然后缓慢旋转放松。这种手法能更好地刺激深层反射。' },
      { type: 'heading', text: '按摩后的反应和效果' },
      { type: 'paragraph', text: '按摩肾脏反射区后，可能会出现以下反应：局部酸胀感、尿液颜色加深（代谢加快的表现）、口渴（需要多喝水）。这些都是正常的调理反应。长期坚持按摩肾脏反射区，可以改善腰膝酸软、提升精力、促进新陈代谢。' },
      { type: 'heading', text: '注意事项' },
      { type: 'paragraph', text: '1. 饭后一小时内不宜进行足底按摩。2. 按摩力度要适中，以舒适为准。3. 按摩后30分钟内不要用冷水洗脚。4. 有严重肾病或足部损伤者应在医生指导下进行。' },
    ],
    tags: ['足底按摩', '反射区', '肾脏保健', '养生技巧'],
    faq: [
      { question: '足底反射区按摩和普通足底按摩有什么区别？', answer: '普通足底按摩主要是放松肌肉，而反射区按摩更注重通过特定区域的刺激来调理对应的器官功能，手法更加精准和有针对性。' },
      { question: '每天都可以做足底反射区按摩吗？', answer: '可以每天进行，但每次时间不宜过长，建议每个反射区按摩2-3分钟，总时长控制在20分钟以内。' },
    ],
  },
  {
    id: 'yaobei-yjbj',
    slug: 'yaobei-yjbj',
    title: '腰肌劳损的按摩调理：一套有效的居家腰背按摩方案',
    categoryId: 'yaobei',
    summary: '针对常见的腰肌劳损问题，提供一套简单易学的居家腰背按摩方案，帮助缓解腰部酸痛，改善腰椎健康。',
    publishDate: '2026-07-18',
    readTime: '11分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Wellness%20room%20with%20yoga%20mat%20and%20massage%20tools%20on%20warm%20wooden%20floor%2C%20soft%20morning%20light%20through%20window%2C%20heating%20pad%20and%20foam%20roller%20nearby%2C%20minimalist%20interior%2C%20calm%20therapeutic%20setting%2C%20cream%20and%20sage%20green%20accents&width=800&height=500&seq=article-yaobei-yjbj&orientation=landscape',
    content: [
      { type: 'heading', text: '认识腰肌劳损' },
      { type: 'paragraph', text: '腰肌劳损是一种常见的腰部软组织损伤，主要表现为腰部酸痛、僵硬，严重时会影响日常活动。长期久坐、不良姿势、突然的腰部用力不当都是导致腰肌劳损的常见原因。通过正确的按摩手法，可以有效缓解症状并促进恢复。' },
      { type: 'heading', text: '急性期与缓解期的按摩策略' },
      { type: 'paragraph', text: '急性期（疼痛剧烈时）：以轻柔的抚摸和热敷为主，避免深度按压。可以用热毛巾敷在腰部15-20分钟，然后用手掌轻轻抚摸腰部肌肉。缓解期（疼痛减轻后）：可以逐步增加按摩力度，进行更深层的肌肉松解。' },
      { type: 'heading', text: '腰部热敷准备' },
      { type: 'paragraph', text: '在按摩开始前，先用热水袋或热敷包敷在腰部15分钟。热敷可以促进局部血液循环，放松紧张的肌肉，为后续的按摩创造良好的条件。热敷温度以不烫伤皮肤为准，一般50-60℃。' },
      { type: 'heading', text: '推揉放松法（5分钟）' },
      { type: 'paragraph', text: '用掌根从腰部两侧向脊柱方向推揉，手法要均匀有力。先用较轻的力度推揉2分钟，让肌肉适应，然后逐渐增加力度。重点按摩腰眼穴（腰部第四腰椎旁开约3-4厘米处）周围区域。' },
      { type: 'heading', text: '点按穴位法（3分钟）' },
      { type: 'paragraph', text: '找到肾俞穴（第二腰椎旁开约1.5寸）、大肠俞穴（第四腰椎旁开约1.5寸）和委中穴（膝盖后方腘横纹中点）。用拇指分别点按这些穴位，每个穴位按压10-15秒后放松，重复3-5次。' },
      { type: 'heading', text: '拉伸放松法（3分钟）' },
      { type: 'paragraph', text: '按摩结束后，进行简单的腰部拉伸。平躺，双膝弯曲，缓慢将膝盖向胸部靠拢，保持15秒。然后做猫式伸展：四肢着地，吸气时弓背，呼气时塌腰，重复10次。' },
      { type: 'heading', text: '日常预防建议' },
      { type: 'paragraph', text: '1. 保持正确的坐姿，腰部要有支撑。2. 每坐1小时起身活动5分钟。3. 加强核心肌群锻炼，如平板支撑和桥式。4. 睡觉时选择软硬适中的床垫。5. 搬重物时注意用腿部发力，不要直接弯腰。' },
    ],
    tags: ['腰背按摩', '腰肌劳损', '居家调理', '运动康复'],
    faq: [
      { question: '腰肌劳损需要多久才能恢复？', answer: '轻度腰肌劳损通过休息和按摩，通常1-2周可以明显改善。中度劳损可能需要3-4周。如果症状持续超过4周没有改善，建议就医检查。' },
      { question: '按摩后腰痛加重了怎么办？', answer: '如果按摩后疼痛加重，说明按摩力度可能过大或手法不当。应立即停止按摩，进行冷敷（急性期）或休息。如果疼痛持续加重，请及时就医。' },
    ],
  },
  {
    id: 'toubu-taiyang',
    slug: 'toubu-taiyang',
    title: '头痛克星：太阳穴与其他头部穴位的按摩指南',
    categoryId: 'toubu',
    summary: '学会正确的头部穴位按摩方法，包括太阳穴、百会穴、风池穴等，有效缓解各种类型的头痛和精神紧张。',
    publishDate: '2026-07-15',
    readTime: '7分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Peaceful%20meditation%20corner%20with%20soft%20cushions%20and%20aromatherapy%20diffuser%2C%20gentle%20candlelight%2C%20head%20massage%20tools%20on%20wooden%20tray%2C%20calm%20and%20serene%20wellness%20space%2C%20warm%20neutral%20colors%2C%20zen%20atmosphere%2C%20professional%20photography&width=800&height=500&seq=article-toubu-taiyang&orientation=landscape',
    content: [
      { type: 'heading', text: '头痛的常见类型' },
      { type: 'paragraph', text: '头痛可以分为紧张性头痛、偏头痛、颈源性头痛等多种类型。其中紧张性头痛最为常见，多由压力、疲劳和不良姿势引起。穴位按摩对于缓解紧张性头痛和颈源性头痛有显著效果。' },
      { type: 'heading', text: '太阳穴按摩法' },
      { type: 'paragraph', text: '太阳穴位于眉梢和外眼角之间向后约一横指的凹陷处。用双手食指和中指指腹同时按压两侧太阳穴，力度适中，以感觉酸胀为度。按压5秒后松开，重复10次。然后进行顺时针旋转按摩，按摩30秒。这个手法对于缓解偏头痛和前额痛特别有效。' },
      { type: 'heading', text: '百会穴按摩法' },
      { type: 'paragraph', text: '百会穴位于头顶正中，两耳尖连线的中点。用中指指腹轻轻按压百会穴，力度要轻柔，按压3秒后松开，重复15次。按摩百会穴可以提神醒脑，缓解头顶痛和头脑昏沉。' },
      { type: 'heading', text: '风池穴按摩法' },
      { type: 'paragraph', text: '风池穴位于后颈部，头骨下方的凹陷处，左右各一个。用双手拇指同时按压两侧风池穴，方向朝对侧眼球，力度适中。按压10秒后松开，重复10次。风池穴是缓解颈源性头痛和感冒头痛的关键穴位。' },
      { type: 'heading', text: '印堂穴按摩法' },
      { type: 'paragraph', text: '印堂穴位于两眉之间。用拇指指腹从印堂穴向上推至发际线，力度由轻到重，重复推按10-15次。这个手法可以有效缓解前额痛和眼部疲劳引起的不适。' },
      { type: 'heading', text: '综合按摩流程' },
      { type: 'paragraph', text: '建议按照以下顺序进行头部按摩：1. 风池穴（2分钟）→ 2. 百会穴（1分钟）→ 3. 太阳穴（2分钟）→ 4. 印堂穴（1分钟）。整个流程约6分钟，每天可进行1-2次。按摩时保持呼吸平稳，效果更佳。' },
    ],
    tags: ['头部按摩', '头痛缓解', '穴位按摩', '压力管理'],
    faq: [
      { question: '按摩太阳穴对偏头痛有效吗？', answer: '对于轻度到中度的偏头痛，按摩太阳穴配合风池穴可以有效缓解疼痛。但如果偏头痛频繁发作或程度严重，建议在按摩的同时就医诊治。' },
      { question: '按摩头部穴位有什么时间限制吗？', answer: '没有严格的时间限制。但建议避免在饭后立即按摩，以及睡前半小时内按摩力度要轻柔。白天工作间隙感到疲劳或头痛时是最佳的按摩时机。' },
    ],
  },
  {
    id: 'jianjing-fsx',
    slug: 'jianjing-fsx',
    title: '肩周炎康复按摩：循序渐进的功能恢复训练',
    categoryId: 'jianjing',
    summary: '肩周炎患者必看的康复按摩教程，从被动按摩到主动训练，系统性地帮助肩关节恢复活动范围和功能。',
    publishDate: '2026-07-12',
    readTime: '13分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Physical%20therapy%20room%20with%20resistance%20bands%20and%20massage%20balls%2C%20warm%20wooden%20interior%2C%20soft%20natural%20light%2C%20therapeutic%20exercise%20equipment%2C%20calm%20rehabilitation%20setting%2C%20cream%20and%20terracotta%20tones%2C%20professional%20wellness%20photography&width=800&height=500&seq=article-jianjing-fsx&orientation=landscape',
    content: [
      { type: 'heading', text: '肩周炎的分期与按摩策略' },
      { type: 'paragraph', text: '肩周炎通常分为三期：疼痛期（主要症状为疼痛）、冻结期（活动受限为主）和恢复期（逐步恢复功能）。不同时期的按摩策略有所不同，需要根据实际情况调整按摩力度和手法。' },
      { type: 'heading', text: '疼痛期的轻柔按摩' },
      { type: 'paragraph', text: '在疼痛期，按摩以轻柔为主，目的是缓解疼痛和放松紧张的肌肉。用温热毛巾敷在肩部10分钟，然后用掌心在肩部进行轻柔的圆周按摩，避开最痛点。可以配合使用具有活血化瘀功效的精油，如姜精油或迷迭香精油。' },
      { type: 'heading', text: '冻结期的深层按摩' },
      { type: 'paragraph', text: '冻结期疼痛减轻但活动受限，此时可以逐步增加按摩力度。重点按摩三角肌、冈上肌和肩胛下肌区域。用拇指进行深层揉捏，每个部位按摩1-2分钟。注意按摩时要配合关节的被动活动——在按摩肌肉的同时轻轻地活动肩关节。' },
      { type: 'heading', text: '关键穴位按压' },
      { type: 'paragraph', text: '肩髃穴（肩峰前下方凹陷处）、肩髎穴（肩峰后下方凹陷处）和肩贞穴（腋后纹头上1寸）是治疗肩周炎的关键穴位。用拇指分别按压这些穴位，每个穴位按压15-20秒，每天2-3次。' },
      { type: 'heading', text: '配合功能锻炼' },
      { type: 'paragraph', text: '按摩后进行功能锻炼效果更佳：1. 爬墙运动：面对墙壁，用手指慢慢向上"爬"，尽量抬高患侧手臂。2. 钟摆运动：弯腰，让患侧手臂自然下垂，做顺时针和逆时针的圆周运动。3. 背后拉手：用健侧手在背后拉住患侧手腕，轻轻向上提拉。' },
      { type: 'heading', text: '康复时间与注意事项' },
      { type: 'paragraph', text: '肩周炎的自然病程通常为1-2年，但通过积极的按摩和功能锻炼，可以显著缩短康复时间。注意事项包括：避免突然的剧烈运动、注意肩部保暖、不要长时间保持一个姿势。如果按摩后疼痛明显加重，应暂停并咨询医生。' },
    ],
    tags: ['肩周炎', '康复按摩', '功能训练', '关节保健'],
    faq: [
      { question: '肩周炎按摩会加重病情吗？', answer: '正确的按摩不但不会加重病情，还能促进恢复。但如果按摩手法不当或力度过大，可能会导致症状加重。建议在专业指导下学习正确的按摩方法。' },
      { question: '肩周炎需要配合药物治疗吗？', answer: '按摩是一种辅助康复手段。在急性疼痛期，可能需要配合消炎镇痛药物。建议在医生的指导下制定综合治疗计划。' },
    ],
  },
  {
    id: 'xuewei-zusanli',
    slug: 'xuewei-zusanli',
    title: '足三里穴：长寿穴位的正确按摩方法与养生功效',
    categoryId: 'xuewei',
    summary: '足三里是中医最著名的保健穴位之一，被称为"长寿穴"。掌握足三里穴的正确按摩方法，增强消化功能和免疫力。',
    publishDate: '2026-07-10',
    readTime: '8分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20medicine%20acupuncture%20model%20with%20herbal%20medicine%20books%20on%20dark%20wooden%20desk%2C%20soft%20warm%20lighting%2C%20traditional%20wellness%20tools%2C%20ginger%20and%20goji%20berries%20in%20ceramic%20bowl%2C%20earthy%20aesthetic%2C%20zen%20photography&width=800&height=500&seq=article-xuewei-zusanli&orientation=landscape',
    content: [
      { type: 'heading', text: '足三里穴的中医地位' },
      { type: 'paragraph', text: '足三里穴是足阳明胃经的合穴，位于小腿前外侧。中医有"若要安，三里常不干"的说法，意指经常刺激足三里穴可以强身健体、延年益寿。它是中医临床使用频率最高的穴位之一。' },
      { type: 'heading', text: '精确定位足三里' },
      { type: 'paragraph', text: '正坐屈膝，找到膝盖外侧的凹陷处（外膝眼），从外膝眼向下量四横指（约3寸）的距离，在胫骨前缘向外一横指（约1寸）的位置就是足三里穴。按压时会有明显的酸胀感向脚背方向放射。' },
      { type: 'heading', text: '艾灸与按摩结合法' },
      { type: 'paragraph', text: '足三里的保健方法主要有两种：艾灸和按摩。艾灸法：用艾条在距离穴位2-3厘米处进行温和灸，每侧灸10-15分钟，以皮肤温热发红为度。按摩法：用拇指指腹按压，按压10秒后松开，每侧重复20-30次。两者结合效果更佳。' },
      { type: 'heading', text: '足三里的主要功效' },
      { type: 'paragraph', text: '1. 调理脾胃：改善消化不良、胃痛、腹胀等问题。2. 增强免疫力：经常按摩足三里可以提升机体免疫力，减少感冒发生。3. 缓解疲劳：对于全身乏力、精神不振有很好的改善效果。4. 辅助降血压：对轻度高血压有一定的辅助调理作用。5. 改善下肢循环：缓解腿部酸胀和疲劳。' },
      { type: 'heading', text: '最佳按摩时间和频率' },
      { type: 'paragraph', text: '根据中医子午流注理论，胃经气血最旺盛的时间是上午7-9点，此时按摩足三里效果最佳。每天按摩1-2次，每次每侧3-5分钟。长期坚持才能体现出养生保健的效果。' },
    ],
    tags: ['足三里', '穴位养生', '中医保健', '脾胃调理'],
    faq: [
      { question: '足三里按摩需要多大的力度？', answer: '以感觉明显酸胀但不疼痛为宜。如果感到刺痛或剧烈疼痛，说明力度过大。按摩后局部有温热感和轻微酸胀是正常反应。' },
      { question: '足三里穴可以用艾灸吗？', answer: '可以，艾灸足三里是非常经典的养生方法。但需要注意艾灸的温度和安全，避免烫伤。孕妇和经期女性慎用。' },
    ],
  },
  {
    id: 'zudi-shimian',
    slug: 'zudi-shimian',
    title: '失眠调理：足底反射区按摩助眠方案',
    categoryId: 'zudi',
    summary: '通过刺激足底的睡眠相关反射区，配合放松按摩手法，改善睡眠质量。一套简单有效的居家足底按摩助眠方案。',
    publishDate: '2026-07-08',
    readTime: '9分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cozy%20bedroom%20with%20foot%20spa%20basin%20and%20soft%20lighting%2C%20lavender%20and%20chamomile%20arrangement%2C%20warm%20blanket%20texture%2C%20nighttime%20relaxation%20scene%2C%20calm%20sleep%20environment%2C%20cream%20and%20soft%20lavender%20tones%2C%20wellness%20lifestyle%20photography&width=800&height=500&seq=article-zudi-shimian&orientation=landscape',
    content: [
      { type: 'heading', text: '失眠与足底按摩的关系' },
      { type: 'paragraph', text: '中医认为"脚为精气之根"，足底有全身各个器官的反射区。通过按摩足底的特定区域，可以调节神经系统功能，促进身体放松，从而改善睡眠。与药物相比，足底按摩没有副作用，是一种安全的助眠方法。' },
      { type: 'heading', text: '助眠相关的足底反射区' },
      { type: 'paragraph', text: '主要的助眠反射区包括：1. 大脑反射区（大脚趾指腹）——调节神经系统。2. 脑垂体反射区（大脚趾指腹中央）——调节内分泌。3. 太阳神经丛反射区（脚掌中心偏上）——放松身心。4. 失眠点（脚后跟中央）——直接助眠。' },
      { type: 'heading', text: '睡前泡脚准备' },
      { type: 'paragraph', text: '睡前1小时用40-45℃的热水泡脚15-20分钟。可以在水中加入薰衣草精油（3-5滴）或艾草，增强放松效果。泡脚时水温要保持恒定，可以用浴巾盖住膝盖以保持温度。泡到身体微微出汗为最佳状态。' },
      { type: 'heading', text: '大脑反射区按摩' },
      { type: 'paragraph', text: '用拇指指腹在大脚趾指腹上做螺旋状按摩，从趾尖向趾根方向推进。力度适中，每侧按摩2-3分钟。这个反射区对应大脑，按摩它可以缓解精神紧张，让思绪平静下来。' },
      { type: 'heading', text: '失眠点按摩' },
      { type: 'paragraph', text: '失眠点位于脚后跟的正中央。用拇指或食指关节在这个位置进行深压按摩，按压5秒后松开，重复20次。然后用拇指在该区域进行顺时针旋转按摩，持续2分钟。' },
      { type: 'heading', text: '完整的睡前足底按摩流程' },
      { type: 'paragraph', text: '1. 泡脚（15分钟）→ 2. 大脑反射区按摩（每侧2分钟）→ 3. 脑垂体反射区按摩（每侧1分钟）→ 4. 太阳神经丛按摩（每侧2分钟）→ 5. 失眠点按摩（每侧2分钟）→ 6. 轻轻按摩整个脚底（每侧1分钟）。整个过程约25分钟。按摩后直接上床休息。' },
    ],
    tags: ['失眠', '助眠按摩', '足底反射区', '睡眠改善'],
    faq: [
      { question: '足底按摩多久可以改善失眠？', answer: '很多人当天晚上就能感受到改善。但要达到稳定的效果，建议坚持每晚进行，连续2-4周后睡眠质量会有明显提升。' },
      { question: '泡脚的水温越高越好吗？', answer: '不是。水温过高会过度刺激血液循环，反而影响入睡。40-45℃是最佳温度，以感觉舒适温暖为宜。' },
    ],
  },
  {
    id: 'yaobei-jianpan',
    slug: 'yaobei-jianpan',
    title: '久坐族的腰背救星：每天10分钟的腰部保健按摩',
    categoryId: 'yaobei',
    summary: '专为久坐不动的上班族设计的腰部保健按摩方案，每天只需10分钟，有效预防和缓解腰痛问题。',
    publishDate: '2026-07-05',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20ergonomic%20home%20office%20with%20lumbar%20support%20cushion%20and%20standing%20desk%2C%20massage%20roller%20on%20chair%2C%20natural%20light%20from%20window%2C%20minimalist%20workspace%2C%20cream%20and%20warm%20wood%20tones%2C%20healthy%20workplace%20photography&width=800&height=500&seq=article-yaobei-jianpan&orientation=landscape',
    content: [
      { type: 'heading', text: '久坐对腰部的危害' },
      { type: 'paragraph', text: '长时间保持坐姿会使腰椎承受比站立时高40%的压力。如果坐姿不正确，这个压力还会进一步增加。久而久之，腰部肌肉会变得僵硬，椎间盘也会受到损伤。据统计，90%的成年人一生中都会经历不同程度的腰痛问题。' },
      { type: 'heading', text: '办公椅上的腰部自我按摩' },
      { type: 'paragraph', text: '即使在办公室里也可以进行简单的腰部按摩：坐直身体，双手握拳，用拳背在腰部两侧上下推按，从腰部推至臀部上方，每侧推按20次。然后用手指按压腰部的痛点，每个痛点按压10秒。这套动作可以在工作间隙随时进行。' },
      { type: 'heading', text: '利用按摩球放松腰肌' },
      { type: 'paragraph', text: '准备一个网球或专用按摩球。靠墙站立，将球放在腰部和墙壁之间，用身体的重量轻轻地压在球上。缓慢地上下左右移动身体，让球在腰部肌肉上进行滚动按摩。每侧按摩3分钟。这个方法的优点是能精准地针对肌肉痛点。' },
      { type: 'heading', text: '泡沫轴腰部放松' },
      { type: 'paragraph', text: '仰卧在地上，将泡沫轴放在腰部下方。弯曲膝盖，双脚平放在地面。用手支撑身体，让泡沫轴在腰部缓慢滚动。注意不要直接在脊柱骨上滚动，应该让泡沫轴在脊柱两侧的肌肉上来回滚动。每次滚动2-3分钟。' },
      { type: 'heading', text: '配合腰部拉伸' },
      { type: 'paragraph', text: '按摩后进行腰部拉伸：1. 仰卧扭转：仰卧，双膝弯曲，缓慢地将双膝倒向一侧，保持20秒，换边。2. 婴儿式：跪坐，身体前倾，额头贴地，手臂向前伸展，保持30秒。3. 桥式：仰卧，臀部抬起，保持15秒，重复8次。' },
      { type: 'heading', text: '改善办公习惯' },
      { type: 'paragraph', text: '除了按摩，改善办公习惯同样重要：1. 选择有腰部支撑的椅子。2. 屏幕高度与眼睛平齐。3. 每坐45分钟起身活动5分钟。4. 双脚平放在地面，不要翘二郎腿。5. 使用腰靠垫支撑腰椎。' },
    ],
    tags: ['久坐保健', '腰部按摩', '办公室放松', '泡沫轴'],
    faq: [
      { question: '使用泡沫轴时腰部疼痛正常吗？', answer: '轻微的酸痛是正常的，说明肌肉有结节和紧张。但如果出现剧烈疼痛或刺痛，应立即停止，可能是施加了过大的压力或在脊柱骨上滚动。' },
      { question: '办公室可以做腰部按摩吗？会不会很奇怪？', answer: '简易的自我按摩动作在办公室完全可行且不会显得突兀。握拳推按腰部是很自然的伸展动作，同事们不会觉得奇怪。按摩球可能需要更私密的空间。' },
    ],
  },
  {
    id: 'quanshen-jingyou',
    slug: 'quanshen-jingyou',
    title: '精油按摩入门：选择适合你的按摩精油与使用技巧',
    categoryId: 'quanshen-fangsong',
    summary: '不同精油有不同的功效。学会根据自身需求选择合适的按摩精油，并掌握正确的精油稀释和使用方法。',
    publishDate: '2026-07-02',
    readTime: '14分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Aromatherapy%20essential%20oil%20collection%20displayed%20on%20marble%20tray%20with%20dried%20lavender%20and%20rosemary%2C%20amber%20glass%20bottles%2C%20soft%20diffused%20light%2C%20luxury%20spa%20aesthetic%2C%20cream%20and%20warm%20gold%20tones%2C%20editorial%20product%20photography&width=800&height=500&seq=article-quanshen-jingyou&orientation=landscape',
    content: [
      { type: 'heading', text: '精油按摩的基础知识' },
      { type: 'paragraph', text: '精油是从植物中提取的浓缩精华，具有独特的香气和功效。通过按摩将精油渗透到皮肤中，可以达到放松身心、缓解疼痛、改善肤质等多重效果。但精油是高浓度物质，使用前必须了解正确的稀释和使用方法。' },
      { type: 'heading', text: '常见按摩精油及功效' },
      { type: 'paragraph', text: '薰衣草精油：放松安神、缓解焦虑、改善睡眠。适合睡前按摩使用。薄荷精油：提神醒脑、缓解头痛、清凉镇痛。适合白天疲劳时使用。迷迭香精油：促进血液循环、缓解肌肉酸痛、提升记忆力。适合运动后按摩。甜橙精油：愉悦心情、缓解压力。气味甜美，适合全身放松按摩。姜精油：温热活血、缓解关节疼痛。适合寒性体质和冬季使用。' },
      { type: 'heading', text: '精油稀释比例指南' },
      { type: 'paragraph', text: '精油绝不能直接涂抹在皮肤上，必须用基础油稀释。常用的基础油包括：甜杏仁油、葡萄籽油、荷荷巴油和椰子油。稀释比例：面部按摩0.5-1%（10ml基础油加1-2滴精油），身体按摩2-3%（10ml基础油加4-6滴精油），局部重点按摩3-5%（10ml基础油加6-10滴精油）。' },
      { type: 'heading', text: '精油按摩的步骤' },
      { type: 'paragraph', text: '1. 准备按摩油：将基础油倒入掌心，再滴入适量精油，双手搓匀。2. 预热：双手搓热后先轻轻覆盖在按摩部位上30秒，让皮肤和肌肉预热。3. 按摩：按照从下到上、从外到内的方向进行按摩。4. 吸收：按摩结束后让精油在皮肤上停留15-20分钟，充分吸收。' },
      { type: 'heading', text: '精油复方搭配推荐' },
      { type: 'paragraph', text: '放松助眠：薰衣草3滴 + 甜橙2滴 + 基础油10ml。缓解肌肉酸痛：迷迭香3滴 + 姜精油2滴 + 薄荷1滴 + 基础油10ml。提神醒脑：薄荷2滴 + 迷迭香2滴 + 柠檬2滴 + 基础油10ml。舒缓压力：薰衣草2滴 + 佛手柑2滴 + 依兰依兰1滴 + 基础油10ml。' },
      { type: 'heading', text: '精油使用安全须知' },
      { type: 'paragraph', text: '1. 使用前先做皮肤敏感测试：将稀释后的精油涂在手腕内侧，观察24小时。2. 孕妇、儿童、癫痫患者使用精油前需咨询医生。3. 柑橘类精油（甜橙、柠檬等）使用后12小时内避免日晒。4. 精油应存放在阴凉避光处，避免高温和阳光直射。5. 精油不可内服。' },
    ],
    tags: ['精油按摩', '芳香疗法', '按摩油', '自然疗法'],
    faq: [
      { question: '精油按摩后可以马上洗澡吗？', answer: '建议等待30分钟到1小时后再洗澡，让精油充分被皮肤吸收。如果立即洗澡，按摩效果会大打折扣。' },
      { question: '不同品牌的精油可以混用吗？', answer: '可以，不同品牌的纯精油可以混用。但建议选择品质可靠的品牌，确保精油的纯度和安全性。劣质精油可能含有化学成分，对皮肤造成刺激。' },
    ],
  },
  {
    id: 'toubu-zimei',
    slug: 'toubu-zimei',
    title: '面部穴位美容按摩：淡化法令纹与提升面部轮廓',
    categoryId: 'toubu',
    summary: '通过面部穴位按摩促进血液循环，改善面部肤色，淡化法令纹和眼角细纹，实现自然的面部提升效果。',
    publishDate: '2026-06-28',
    readTime: '10分钟',
    imageUrl: 'https://readdy.ai/api/search-image?query=Beauty%20skincare%20setup%20with%20jade%20roller%20and%20facial%20oil%20on%20white%20marble%2C%20fresh%20rose%20petals%2C%20soft%20natural%20lighting%2C%20elegant%20spa%20aesthetic%2C%20cream%20and%20blush%20pink%20tones%2C%20luxury%20skincare%20photography&width=800&height=500&seq=article-toubu-zimei&orientation=landscape',
    content: [
      { type: 'heading', text: '面部穴位按摩的美容原理' },
      { type: 'paragraph', text: '面部有众多穴位与经络相连，通过按摩这些穴位可以促进面部血液循环、加速新陈代谢、增加皮肤弹性。长期坚持面部穴位按摩，可以改善肤色暗沉、淡化细纹、提升面部轮廓，是一种安全无创的自然美容方法。' },
      { type: 'heading', text: '准备工作' },
      { type: 'paragraph', text: '清洁面部后，涂抹适量的面部按摩油或精华液，减少摩擦力，同时让有效成分更好地渗透。建议使用玫瑰果油、荷荷巴油或专用的面部按摩膏。确保双手清洁，指甲修剪整齐，避免划伤皮肤。' },
      { type: 'heading', text: '淡化法令纹——迎香穴和地仓穴' },
      { type: 'paragraph', text: '迎香穴位于鼻翼两侧的凹陷处，地仓穴位于嘴角外侧约0.5厘米处。用双手中指同时按压迎香穴，按压5秒后向地仓穴方向滑动按摩，重复15次。这个动作可以促进鼻唇沟区域的血液循环，帮助淡化法令纹。' },
      { type: 'heading', text: '提升面部轮廓——颊车穴和下关穴' },
      { type: 'paragraph', text: '颊车穴位于下颌角前上方约一横指处，下关穴位于颧弓下缘的凹陷处。用双手食指和中指同时按压这两个穴位，然后从下向上提拉按摩，每个穴位按压10秒后做提拉动作10次。这个手法有助于紧致面部轮廓。' },
      { type: 'heading', text: '淡化眼角纹——睛明穴和太阳穴' },
      { type: 'paragraph', text: '睛明穴位于眼内角上方约0.3厘米处。用无名指（力度最轻柔）轻轻按压睛明穴，按压3秒后松开，重复10次。然后用中指按摩太阳穴1分钟。眼周皮肤非常娇嫩，按摩时力度一定要轻柔，避免拉扯皮肤。' },
      { type: 'heading', text: '完整的面部按摩流程' },
      { type: 'paragraph', text: '1. 额头提升（1分钟）：从眉心向上推至发际线。2. 眼部放松（2分钟）：按压睛明穴→沿眼眶按摩→太阳穴。3. 法令纹淡化（2分钟）：迎香穴→地仓穴滑动按摩。4. 面颊提升（2分钟）：颊车穴→下关穴提拉按摩。5. 下巴紧致（1分钟）：从下巴中心向耳后推按。6. 颈部淋巴引流（1分钟）：从耳后向下推至锁骨。' },
      { type: 'heading', text: '按摩后的护理' },
      { type: 'paragraph', text: '按摩后用温水轻拍面部，帮助剩余的精油吸收。然后按照正常的护肤流程涂抹爽肤水、精华和面霜。建议晚上进行面部按摩，因为夜间是皮肤修复的黄金时间。每周进行3-4次即可，不宜过于频繁。' },
    ],
    tags: ['面部美容', '穴位按摩', '抗衰老', '自然护肤'],
    faq: [
      { question: '面部按摩会让皮肤松弛吗？', answer: '不会。正确的面部按摩（向上提拉的方向）反而能帮助紧致皮肤。关键在于按摩方向必须是向上的，不能用向下拉扯的手法。' },
      { question: '面部按摩多久能看到效果？', answer: '即时效果（面部红润、紧致感）可以当场感受到。淡化细纹和提升轮廓的长期效果需要坚持4-8周，每周3-4次。' },
    ],
  },
];

export const getArticleById = (id: string) => articles.find((a) => a.id === id);

export const getArticlesByCategory = (categoryId: string) =>
  articles.filter((a) => a.categoryId === categoryId);

export const getFeaturedArticles = (count: number = 6) => articles.slice(0, count);